import React from 'react';
import { SvgIcon } from '@material-ui/core';

export function GatewayTransferIcon(props) {
    return (
      <SvgIcon {...props}>
        <path d="m1.69 6.9-.8-.86c1.39-1.52 3.18-2.27 4.97-2.27s3.58.76 4.97 2.27l-.8.86C8.84 5.72 7.34 5.06 5.85 5.06c-1.49 0-2.98.66-4.18 1.84m.9.87c.9-.97 2.09-1.52 3.28-1.52s2.39.55 3.28 1.52l-.8.87c-.7-.76-1.59-1.08-2.49-1.08s-1.79.32-2.49 1.08l-.8-.87m.3 6.81h1.99v-4.33h1.99v4.33h9.94c1.09 0 1.99.97 1.99 2.16v4.33c0 1.19-.9 2.16-1.99 2.16H2.85c-1.09 0-1.99-.97-1.99-2.16v-4.33c0-1.19.9-2.16 1.99-2.16m10.94 5.41h1.99v-2.16h-1.99v2.16m-3.48 0h1.99v-2.16h-1.99v2.16m-3.48 0h1.99v-2.16H6.83v2.16zM18.12 13.79l5.78-5.16-5.78-5.16v3.27H12v3.79h6.12v3.25z"/>
      </SvgIcon>
    );
}

export function GatewayAddIcon(props) {
    return (
      <SvgIcon {...props}>
        <path d="m1.69 6.9-.8-.86c1.39-1.52 3.18-2.27 4.97-2.27s3.58.76 4.97 2.27l-.8.86C8.84 5.72 7.34 5.06 5.85 5.06c-1.49 0-2.98.66-4.18 1.84m.9.87c.9-.97 2.09-1.52 3.28-1.52s2.39.55 3.28 1.52l-.8.87c-.7-.76-1.59-1.08-2.49-1.08s-1.79.32-2.49 1.08l-.8-.87m.3 6.81h1.99v-4.33h1.99v4.33h9.94c1.09 0 1.99.97 1.99 2.16v4.33c0 1.19-.9 2.16-1.99 2.16H2.85c-1.09 0-1.99-.97-1.99-2.16v-4.33c0-1.19.9-2.16 1.99-2.16m10.94 5.41h1.99v-2.16h-1.99v2.16m-3.48 0h1.99v-2.16h-1.99v2.16m-3.48 0h1.99v-2.16H6.83v2.16zM13.74 6.91h3.03V3.88h2.85v3.03h3.03v2.85h-3.03v3.03h-2.85V9.76h-3.03z"/>
      </SvgIcon>
    );
}

export function GatewayReplaceIcon(props) {
    return (
      <SvgIcon {...props}>
        <path d="m1.69 6.9-.8-.86c1.39-1.52 3.18-2.27 4.97-2.27s3.58.76 4.97 2.27l-.8.86C8.84 5.72 7.34 5.06 5.85 5.06c-1.49 0-2.98.66-4.18 1.84m.9.87c.9-.97 2.09-1.52 3.28-1.52s2.39.55 3.28 1.52l-.8.87c-.7-.76-1.59-1.08-2.49-1.08s-1.79.32-2.49 1.08l-.8-.87m.3 6.81h1.99v-4.33h1.99v4.33h9.94c1.09 0 1.99.97 1.99 2.16v4.33c0 1.19-.9 2.16-1.99 2.16H2.85c-1.09 0-1.99-.97-1.99-2.16v-4.33c0-1.19.9-2.16 1.99-2.16m10.94 5.41h1.99v-2.16h-1.99v2.16m-3.48 0h1.99v-2.16h-1.99v2.16m-3.48 0h1.99v-2.16H6.83v2.16zM19.38 15.495l4.52-4.03-4.52-4.03v2.56H14.6v2.96h4.78v2.55zM14.67.12l-4.52 4.03 4.52 4.03V5.62h4.78V2.66h-4.78V.11z"/>
      </SvgIcon>
    );
}


// WEBPACK FOOTER //
// ./src/Assets/Icons/Sikom.js